<script lang="ts">
    import { type Icon, getIcon, getIconSize } from "$assets/icons";

    export let id: Icon;
    export let title: string | undefined = undefined;
    export let parentHover = false;
    export let secondaryColor: string | boolean = true;
    let size = getIconSize(id);

    if (size === undefined) {
        console.error("loading unknown icon:", id);
        id = "missing-24";
        size = 24;
    }

    $: secColor = secondaryColor === true ? "var(--tacc)" : secondaryColor;
</script>

<!----------------------------------------------------------------------------->

<div
    class="icon"
    class:parent-hover={parentHover}
    class:colored-hover={secondaryColor}
    style="--svg: url(/{getIcon(id)}); --svg-secondary: url(/{getIcon(id)}-secondary); font-size: {size / 16}rem; --acc-color: {secColor};"
    {title}
    on:click
/>

<!----------------------------------------------------------------------------->

<style>
    .icon {
        display: inline-block;
        width: 1em;
        height: 1em;
        position: relative;
    }

    .icon::before {
        position: absolute;
        content: "";
        width: 1em;
        height: 1em;
        mask: var(--svg);
        mask-size: contain;
        background: currentColor;
    }

    .icon::after {
        position: absolute;
        content: "";
        width: 1em;
        height: 1em;
        mask: var(--svg-secondary);
        mask-size: contain;
        background: currentColor;
    }

    :global(*):hover > .parent-hover.colored-hover::after, :not(.parent-hover).colored-hover:hover::after  {
        background: var(--acc-color);
    }
</style>
